import { render, staticRenderFns } from "./WannasornResultModal.vue?vue&type=template&id=feea3cce"
import script from "./WannasornResultModal.vue?vue&type=script&lang=js"
export * from "./WannasornResultModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports